import { render } from "./MscopeNav.vue?vue&type=template&id=dd270f8a&scoped=true"
import script from "./MscopeNav.vue?vue&type=script&lang=js"
export * from "./MscopeNav.vue?vue&type=script&lang=js"

import "./MscopeNav.vue?vue&type=style&index=0&id=dd270f8a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd270f8a"]])

export default __exports__